import Email from "@/domain/entities/emails/Email";
import useMailKeptTodos from "@/hooks/useMailKeptTodos";
import { getLinksFromMailsList, getTodosFromMailsList } from "@/lib/utils";
import { Link as LinkIcon, ListTodoIcon, Paperclip } from "lucide-react";

type MailIconsProps = {
    mail: Email;
};

const TODO_ICON_CLASS_NAME =
    "h-4 w-4 shrink-0 [@container_mailrow_(max-width:460px)]:hidden";

// Mail sans analyse (corbeille, archive, Inbox pas encore analysé) : ses todos conservés viennent
// du widget. Composant à part pour que seules ces lignes s'abonnent au widget (toasts, réseau).
const KeptTodosIcon = ({ mail }: MailIconsProps) => {
    const mailKeptTodos = useMailKeptTodos(mail);

    if (!mailKeptTodos?.keptTodos.length) return null;

    return <ListTodoIcon className={TODO_ICON_CLASS_NAME} />;
};

const MailIcons = ({ mail }: MailIconsProps) => (
    <div className="flex shrink-0 gap-1.5 text-text-caption" id="icons">
        {mail.aiDetails ? (
            getTodosFromMailsList([mail]).length > 0 && (
                <ListTodoIcon className={TODO_ICON_CLASS_NAME} />
            )
        ) : (
            <KeptTodosIcon mail={mail} />
        )}
        {getLinksFromMailsList([mail]).length > 0 && (
            <LinkIcon className="h-4 w-4 shrink-0 [@container_mailrow_(max-width:420px)]:hidden" />
        )}
        {mail.hasAttachment && (
            <Paperclip className="h-4 w-4 shrink-0 [@container_mailrow_(max-width:380px)]:hidden" />
        )}
    </div>
);

export default MailIcons;
